import React from 'react';
import cn from 'classnames';

import {colorIncidentStatus} from '../../lib/colors';
import {translateIncidentStatus} from './translateIncidentStatus';

import StatusBadge from './StatusBadge';

import styles from './StatusBadge.module.scss';

interface IIncidentStatusBadgeProps {
    resolved: boolean
    className?: string
}

const IncidentStatusBadge: React.FC<IIncidentStatusBadgeProps> = ({resolved, className}) => (
    <div className={cn(resolved && styles.resolve)}>
        <StatusBadge
            color={colorIncidentStatus(resolved)}
            label={translateIncidentStatus(resolved)}
            className={cn(styles.status_incident, className)}
        />
    </div>
);

export default IncidentStatusBadge;
